DJ.addBehavior('video-bg', '.video-bg', {
    attach: function(context, settings, behavior) {
      const videoBg = jQuery(this).find('video').get(0);
      if (videoBg) {
        videoBg.play();
      }
    },
    detach: function(context, settings) {}
});
